import styled from '@emotion/styled'
import { MouseEventHandler, RefObject, useRef } from 'react'
import { useVideoProgressTracker } from '../../hooks/useVideoProgressTracker'
import { PlaylistPlayerVideo } from '../../types'

const ScrubbingContainer = styled.div({
    position: 'absolute',
    top: 0,
    zIndex: 3,
    width: '100%',
    backgroundColor: 'transparent',
    pointerEvents: 'all',
})

export const VideoScrubber: React.FC<{
    progressPercentage: number
    onClick: (percent: number) => void
}> = ({ progressPercentage, onClick }) => {
    const progressContainerRef = useRef<HTMLDivElement>(null)

    const _onClick: MouseEventHandler = (event) => {
        const wideDiv = progressContainerRef.current
        if (!wideDiv) return

        const percentage =
            ((event.clientX - wideDiv.getBoundingClientRect().left) /
                wideDiv.clientWidth) *
            100
        onClick(percentage)
    }
    return (
        <ScrubbingContainer ref={progressContainerRef} onClick={_onClick}>
            <div
                style={{
                    height: 4,
                    width: '100%',
                    backgroundColor: 'transparent',
                }}
            >
                <div
                    style={{
                        height: 4,
                        width: `${progressPercentage}%`,
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        transition: 'width 33ms linear',
                    }}
                />
            </div>
        </ScrubbingContainer>
    )
}

export const VideoProgressTrackerAndScrubber: React.FC<{
    playerVideo: PlaylistPlayerVideo
    videoRef: RefObject<HTMLVideoElement>
}> = ({ playerVideo, videoRef }) => {
    const { progressPercent, scrubByPercent } = useVideoProgressTracker(
        playerVideo,
        videoRef,
    )

    return (
        <VideoScrubber
            progressPercentage={progressPercent}
            onClick={scrubByPercent}
        />
    )
}
